import BaseTagStore from './_baseTagStore';

export default class EmployerStore extends BaseTagStore {
  constructor() {
    const baseItem = {
      certType: 'employer',
      companies: [],
      createdAt: null,
      isVerified: false,
      level: -1,
      linked: [],
      parent: null,
      title: null,
      updatedAt: null,
      users: [],
      uuid: null,
    };
    super({ baseItem, serviceName: 'employers' });

    return this;
  }
}
